/**
 * THIS FILE IS GENERATED, DO NOT DIRECTLY EDIT
 */
import { IssuerConfig } from '@ui/services/contract/hooks/LVToken/types';
import { ChainId } from '@ui/types/chain';

export const issuer_raw = {
  10143: [
    {
      tokenAddress: '0x76903262B1d4b70E3F2a5Af8Ed9F7E8Ace646Dcc',
      issuerAddress: '0xea1b8E4aB7f14F7dCA68c5B214303B13078FC5ec',
      lvTokenSymbol: 'LVUSD',
      transparency: '0x9A145489c8975AF222b1516b1C3BB538f8B53410',
    },
    {
      tokenAddress: '0xBe3fa50514D9617ce645a02B34F595541AF02b6b',
      issuerAddress: '0x8C9B7d81307a4631d0C8D83B3DEe05CAA6eaD9a5',
      lvTokenSymbol: 'LVMON',
      transparency: '0x127ba43215875D98d61db28dcc45d37129BD71F9',
    },
  ],
} as unknown as Record<ChainId, IssuerConfig[]>;
